module.exports = __webpack_public_path__ + "static/partner-1-27db37656e8a4ca6a71f8250b527f87a.png";